<div class="col fo-p">
<div id="right-side-panel">
 
    <div id="template-title">
      <span >Template</span>  
      <span><a class="button is-small mobile-close-btn"  (click)="hidePanel('rightpanel')">
      <i class="fa fa-close"></i>
      </a></span>
  </div> 
    <div class="columns">
      <ul id="designlist">
        <li (click)="changeTemplate('bot')" [class.active]="botTemplateName=='bot'"><img  src="../../../assets/images/template-design-2.png"></li>
        <li (click)="changeTemplate('normal')" [class.active]="botTemplateName=='normal'"><img  src="../../../assets/images/template-design-1.png"></li>
      </ul>
    </div>
 
</div>
</div>